import axios from "@/lib/axios";
import { ChangePlanRequestParams } from "../types";

const createChangePlanRequest = (data: ChangePlanRequestParams) => {
  return axios.post("/customer/flat_rates/change_plan_request", data);
}

export default createChangePlanRequest;